import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c059169e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c059169e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c059169e')) {
      api.createRecord('c059169e', component.options)
    } else {
      api.reload('c059169e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c059169e&scoped=true", function () {
      api.rerender('c059169e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsCard/index.vue"
export default component.exports